module.exports = __webpack_public_path__ + "img/icmcup-old.cd7faeec.svg";